
import { defineComponent } from "vue";
import TitlebarButtons from "@/components/shared/TitlebarButtons.vue"; // @ is an alias to /src
import axios from "axios";

export default defineComponent({
  name: "Info",
  components: {
    TitlebarButtons
  },
  data: () => ({
    title: "Informationen",
    current: 0,
    filter: "",
    infos: [] as {
      category: string;
      title: string;
      date: string;
      content: string;
    }[]
  }),
  emits: ["update-focus", "update-maximization"],
  created: function() {
    axios
      .get("./_content/infos.json")
      .then((response) => {
        this.infos = response.data;
        this.filter = this.infos[0]?.category;
      })
      .catch((error) => console.error(error));
  },
  methods: {
    updateFocus(focusValue: string) {
      this.$emit("update-focus", focusValue);
    },
    updateMaximization() {
      this.$emit("update-maximization", "info");
    },
    getCategories() {
      return this.infos
        ?.map((i) => i.category)
        ?.filter((value, index, self) => self.indexOf(value) === index);
    },
    getInfos() {
      return this.infos?.filter((i) => i.category === this.filter);
    },
    getTeaser(text: string) {
      const regex = /(<([^>]+)>)/gi;
      return text.replace(regex, "").substring(0, 50);
    }
  }
});
